export type HomeState = {
  ready: boolean;
};

const initialState: HomeState = {
  ready: true,
};

export default function Home(state: HomeState = initialState): HomeState {
  return state;
}
